/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Document_RestoredInputs */

const cs_enum_document_restored = /** @type {(inputs: Enum_Document_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument obnoven`)
};

const en_enum_document_restored = /** @type {(inputs: Enum_Document_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document restored`)
};

/**
* | output |
* | --- |
* | "Document restored" |
*
* @param {Enum_Document_RestoredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_document_restored = /** @type {((inputs?: Enum_Document_RestoredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Document_RestoredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_document_restored(inputs)
	return cs_enum_document_restored(inputs)
});